import styled, { css } from 'styled-components';

import { placeholderAnimate } from 'utils/style/animations';
import {
  black,
  blue,
  exactWhite,
  gray,
  green,
  lightGreen,
} from 'utils/style/colors';

import { StyledTextarea } from 'components/Textarea/Textarea';

interface IChatMessageWrapperProps {
  whoIsSender: 'others' | 'myself' | 'system';
}

interface IChatMessageProps {
  hasImage?: boolean;
  selfMessage: boolean;
}

const setDirection = {
  others: 'flex-end',
  system: 'center',
  myself: 'flex-start',
};

const placeholderAnimateRule = css`
  ${placeholderAnimate} 1s linear forwards infinite;
`;

export const ChatMessageWrapper = styled('div')<IChatMessageWrapperProps>`
  direction: rtl;
  flex: none;
  margin: 0.7rem 0;
  display: flex;
  align-items: ${(props) => setDirection[props.whoIsSender]};
  flex-direction: column;
`;

export const MessageWrapper = styled('div')`
  display: flex;
  align-items: flex-start;
`;

export const ChatMessage = styled('span')<IChatMessageProps>`
  & > * {
    word-break: break-word;
  }
  color: ${black};
  padding: 0.7rem;
  word-break: normal;
  display: flex;
  position: relative;
  font-size: 14px;
  min-width: 4rem;
  align-items: center;
  font-weight: 400;
  white-space: pre-wrap;
  border-radius: 15px;
  flex-direction: column;
  background-color: #add5ff;
  ${({ selfMessage }) =>
    !selfMessage &&
    `
    // color: var(--exact-white);
    background-color: #dcdcdc;
    :before {
      top: -6px;
      left: 24px;
      width: 0px;
      height: 0px;
      content: '';
      position: absolute;
      border-inline-end: 6px solid transparent;
      border-inline-start: 6px solid transparent;
      border-bottom: 6px solid #dcdcdc;
    }
  `}
  ${({ hasImage }) =>
    hasImage &&
    `
  justify-content: center;
`}


// self bubble

 ${(props) =>
    props.selfMessage &&
    ` 
   align-self: flex-end;
  &::before {
    border-bottom-left-radius: 0.8rem 0.7rem;
    border-right: 1rem solid #add5ff;
    right: -0.35rem;
    transform: translate(0, -0.1rem);
    bottom: -0.1rem;
    content: '';
    height: 1rem;
    position: absolute;
  }
  &::after {
    background-color: var(--exact-white);
    border-bottom-left-radius: 0.5rem;
    right: -40px;
    transform: translate(-30px, -2px);
    width: 10px;
    bottom: -0.1rem;
    content: '';
    height: 1rem;
    position: absolute;
  }
  `}
`;

export const SystemMessage = styled('span')`
  color: ${black};
  background: ${lightGreen};
  padding: 0.7rem;
  text-align: center;
  border-radius: 1rem;
  cursor: ${(props) => (props.isCollapsible ? 'pointer' : 'default')};
`;

export const ImageMessage = styled('img')`
  max-width: 128px;
  max-height: 128px;
  border-radius: 25px;
`;

export const AvatarWrapper = styled('div')`
  display: flex;
  align-items: center;
  margin-bottom: 0.8rem;
`;

export const UserAvatar = styled('span')`
  width: 1rem;
  height: 1rem;
  border-radius: 25px;
  margin-right: 0.6rem;
  background: ${green};
`;

export const MessageTime = styled('span')`
  color: #454d56;
  font-size: 12px;
`;

export const SenderName = styled('span')`
  color: #454d56;
  font-size: 12px;
  font-weight: 400;
  margin-right: 0.5rem;
  border-radius: 0 0 20px 20px;
`;

export const SendMessageInput = styled.div`
  width: 100%;
  z-index: 1000000;
  background-color: var(--exact-white);
  position: relative;
  border-radius: 0 0 20px 20px;
  color: black;
`;

export const IconsWrapper = styled('span')`
  ${(props) => (props.side === 'left' ? 'left: 0' : 'right: 0')};
  color: #999999;
  bottom: 0;
  height: 70px;
  display: flex;
  position: absolute;
  font-size: 15px;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  align-items: center;
  border-radius: 3rem;
  padding-inline-end: 2rem;
  justify-content: flex-end;
`;

export const MessageInput = styled(StyledTextarea)`
  overflow-x: hidden;
  &&& {
    margin: 0 !important;
    border-radius: 0 0 6px 6px !important;
    resize: none;
    display: flex;
    padding: 0.7rem 1rem 0.6rem 8rem !important;
    box-shadow: 0px -2px 15px rgba(0, 0, 0, 0.1) !important;
    color: ${black} !important;

    &::placeholder {
      font-weight: 500 !important;
    }
  }
`;

export const SendMessageWrapper = styled('span')`
  display: flex;
  min-height: 70px;
  // align-items: center;
`;

export const SendMessageIconWrapper = styled('span')`
  color: var(--exact-white);
  width: 2.6rem;
  height: 2.6rem;
  cursor: pointer;
  padding: 0.5rem;
  display: flex;
  font-size: 22px !important;
  font-weight: 500 !important;
  margin-right: 1rem;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  background-color: ${blue};
`;

export const ChooseFileInput = styled('input')`
  display: none;
`;

export const LoadingParent = styled('div')`
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  position: absolute;
  justify-content: center;
`;

export const ChatContainer = styled('div')`
  flex: 1;
  display: flex;
  overflow: auto;
  flex-direction: column;
`;

export const MsgList = styled('div')`
  flex: 1;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  display: flex;
  padding: 1.5rem;
  position: relative;
  overflow-y: auto;
  overflow-x: hidden;
  flex-direction: column;
  padding-bottom: 1rem;
  background: ${exactWhite};
  background-image: url("data:image/svg+xml,%3Csvg width='6' height='6' viewBox='0 0 6 6' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='%239C92AC' fill-opacity='0.21' fill-rule='evenodd'%3E%3Cpath d='M5 0h1L0 6V5zM6 5v1H5z'/%3E%3C/g%3E%3C/svg%3E");
`;

export const ChatInputLoading = styled('div')`
  width: 100%;
  height: 5rem;
  background: var(--exact-white);
  background: linear-gradient(to right, ${gray} 2%, #ddd 18%, ${gray} 33%);
  box-shadow: 0px -2px 15px rgba(0, 0, 0, 0.1) !important;
  animation: ${placeholderAnimateRule};
  background-size: 1300px;
  border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px;
  border-top: 1px solid #c8cee0;
`;

export const ChatNotAllowedBox = styled('div')`
  height: 5rem;
  border-top: 1px solid #c8cee0;
  border-bottom-left-radius: 6px;
  font-weight: 400;
  color: #767676;
  box-shadow: 0px -2px 15px rgba(0, 0, 0, 0.1) !important;
  border-bottom-right-radius: 6px;
  background: ${gray};
  display: flex;
  justify-content: center;
  align-items: center;
`;
